import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard } from 'swiper/modules';

const production = () => {
    const swiper = new Swiper('.swiper-container-production', {
        modules: [Navigation, Pagination, Keyboard],
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: false,
        speed: 800,
        spaceBetween: 20,
        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
        },
        breakpoints: {
            1024: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1280: {
                slidesPerView: 2,
                spaceBetween: 42,
            },
        },

    });

    // Custom navigation - exact 1 slide per click
    const nextButton = document.querySelector('.swiper-production-next');
    const prevButton = document.querySelector('.swiper-production-prev');

    if (nextButton) {
        nextButton.addEventListener('click', () => {
            swiper.slideTo(swiper.activeIndex + 1);
        });
    }

    if (prevButton) {
        prevButton.addEventListener('click', () => {
            swiper.slideTo(swiper.activeIndex - 1);
        });
    }

    // Update button states
    swiper.on('slideChange', () => {
        if (prevButton) {
            if (swiper.activeIndex === 0) {
                prevButton.classList.add('swiper-button-disabled');
            } else {
                prevButton.classList.remove('swiper-button-disabled');
            }
        }

        if (nextButton) {
            if (swiper.activeIndex === swiper.slides.length - 1) {
                nextButton.classList.add('swiper-button-disabled');
            } else {
                nextButton.classList.remove('swiper-button-disabled');
            }
        }
    });

    // Initialize button states
    swiper.emit('slideChange');


};

export { production as default };
